<template>
  <transition name="fade">
    <div class="d-contents">
      <div v-if="open" class="modal-container">
        <component
          :is="component"
          v-on-click-outside="handleClickOutside"
          class="modal-container__component"
          :class="get(context, 'attributes.class', '')"
          :context="context"
          @close="handleClose"
        />
      </div>
      <div v-if="nested.open" class="modal-container">
        <component
          :is="nested.component"
          v-on-click-outside="handleClickOutside"
          class="modal-container__component"
          :class="get(nested.context, 'attributes.class', '')"
          :context="nested.context"
          @close="handleClose"
        />
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import get from 'lodash.get';
  import { handleModalClose } from '@/utils/click-outside';

  export default {
    name: 'Modal',
    computed: {
      ...mapState('modal', ['component', 'context', 'open', 'nested']),
      nonclosable() {
        return !!this.context?.nonclosable;
      },
    },
    methods: {
      ...mapActions({
        close: 'modal/closeModal',
        nestedClose: 'modal/close',
      }),
      handleClose() {
        if (!this.nested.open) {
          this.clearQuery();
          this.close();
        } else {
          this.close(true);
        }
      },
      clearQuery() {
        let query = Object.assign({}, this.$route.query);
        if (query.modal) {
          delete query.modal;
          this.$router.replace({ query });
        }
      },
      handleClickOutside(event) {
        if (!this.nonclosable) {
          handleModalClose(event, () => this.handleClose());
        }
      },
      get,
    },
  };
</script>

<style lang="scss">
  .modal-container {
    padding: 20px;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1000;

    background: rgba(40, 43, 46, 0.7);
    backdrop-filter: blur(11px);
    overflow: auto;
  }

  .modal-container__component {
    margin: auto;
    overflow: initial;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
  }
</style>
